import React from "react";
import styles from "../company.module.css";

// Interruptor controlado: el padre decide el valor (optimista) y lo revierte
// si el backend falla.
export default function Toggle({ checked, onChange, disabled, label }) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={!!checked}
      aria-label={label}
      title={label}
      disabled={disabled}
      className={`${styles.toggle} ${checked ? styles.toggleOn : ""}`}
      onClick={() => onChange(!checked)}
    />
  );
}
